import { useForm as createUseForm } from "@ant-design-vue/use";
import { defineAsyncComponent } from "vue";
import { createFieldInput, createFieldInputPassword } from "../../../components/input/template-builder/template-builder.logic";
import i18n from '../../../i18n';
import router from '../../../router';
import store from '../../../store';
import { createLoading } from "../../../utils/loading";
import { required, validateError } from "../../../utils/validate";

export const CIcon = defineAsyncComponent(() => import('../../../components/icon/CIcon'))

export const { isLoading, setIsLoading } = createLoading()

export const callLogin = ({ form }) => store.dispatch(`resource/auth/login`, { data: form, config: { isNotification: false } })

export const onClickLogin = ({ data }) => {
    const { useForm } = data
    const { modelRef } = useForm
    return data.useForm
        .validate()
        .then(() => {
            setIsLoading(true)
            return callLogin({ form: data.useForm.modelRef })
                .finally(() => setIsLoading(false))
                .then(() => {
                    const redirectUrl = router.currentRoute.value.query.url || "/";
                    router.push({ path: redirectUrl });
                })
                .catch((error) => {
                    modelRef.password = ''
                    useForm.resetFields(modelRef);
                    const message = error.response?.data?.message
                    if (message) {
                        data.errorMessage = i18n.global.t(message);
                    }
                });
        })
        .catch((error) => validateError({ error }));
}

export const createForm = () => {
    return {
        username: null,
        password: null,
    }
}

export const createRules = () => {
    return {
        username: [required],
        password: [required],
    }
}

export const createField = ({ props, data, refs }) => {
    const { useForm } = data
    const { modelRef } = useForm
    return [
        createFieldInput({
            key: 'username',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            label: () => i18n.global.t('model.user.username'),
            inputProp: () => ({
                value: modelRef.username,
                'onUpdate:value': value => modelRef.username = value,
                prefix: () => <CIcon file="username.svg"></CIcon>,
                onKeyup: (e) => {
                    if (e.keyCode === 13) {
                        refs.password.focus();
                    }
                }
            })
        }),
        createFieldInputPassword({
            key: 'password',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            label: () => i18n.global.t('model.user.password'),
            inputProp: () => ({
                value: modelRef.password,
                'onUpdate:value': value => modelRef.password = value,
                prefix: () => <CIcon file="password.svg"></CIcon>,
                ref: (e) => refs.password = e,
                onKeyup: (e) => {
                    if (e.keyCode === 13) {
                        onClickLogin({ props, data, refs })
                    }
                }
            })
        }),
    ]
}

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
}